export const styles = {
  button: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '12px',
    border: '1px solid rgba(238, 67, 96, 1)',
    padding: '8px 16px',
    cursor: 'pointer',

    minWidth: '89px',
    fontWeight: '700',
    textDecoration: 'none !important',
    '@media screen and (max-width: 768px)': {
      borderRadius: '16px',
    },
    '&:hover': {
      textDecoration: 'none !important',
    },
    '&:active': {
      textDecoration: 'none !important',
    },
  },
  primary: {
    backgroundColor: 'rgba(238, 67, 96, 1)',
    color: '#FFFFFF !important',
    '&:hover': {
      backgroundColor: '#FFFFFF',
      color: ' rgba(238, 67, 96, 1) !important',
    },
  },
  secondary: {
    backgroundColor: '#FFFFFF',
    color: 'rgba(238, 67, 96, 1) !important',
    '&:hover': {
      backgroundColor: 'rgba(238, 67, 96, 1)',
      color: '#FFFFFF !important',
    },
  },

  secondaryBlack: {
    backgroundColor: '#FFFFFF',
    color: 'black !important',
    border: '1px solid black',
    '&:hover': {
      backgroundColor: '#FFFFFF',
      color: 'black !important',
      border: '1px solid black',
    },
  },

  disabled: {
    backgroundColor: '#AEAFC7',
    border: '1px solid #AEAFC7',
    color: '#FFFFFF !important',
    cursor: 'default',
    '&:hover': {
      backgroundColor: '#AEAFC7',
      border: '1px solid #AEAFC7',
      color: '#FFFFFF !important',
    },
  },
}
